// extracted by mini-css-extract-plugin
export default {"sidebarToggleButton":"ListSidebar-module__sidebarToggleButton--lQf1m","sidebarHeading":"ListSidebar-module__sidebarHeading--b2v21"};